import React from "react"
import foodCartIcon from "../../assets/images/food-cart-icon.svg"
import _ from "../../utils/lodashUtils"
import "./CartPopup.scss"
import {
  FIREBASE_STATE_KEYS,
  FirebaseContext,
  FirebaseService,
} from "../../firebase"
import { SUGGESTION_STATES, CUSTOM_EVENTS } from "../../constants/commons"
import { withRouter } from "react-router"
import { isPartnerAway, getPartnerNameorNickName } from "../../utils/helpers"
import { CartView } from "./CartView"
import {
  YOUR_PLATES,
  PARTNER_READY_FOR_CHECKOUT,
  GO_TO_CHECKOUT,
} from "../../constants/messages"
import { TextTag as Text, CustomModal, Button } from "../../atoms"
import { useRef } from "react"
import { emitter } from "../../utils/emitter"

// Component when clicked on plates in menu page
export const CartPopup = withRouter(props => {
  const [visible, setVisible] = React.useState(false)
  const { partnerState, userState } = React.useContext(FirebaseContext)
  const userDetails = _.get(userState, FIREBASE_STATE_KEYS.USER_DETAILS, {})
  const userUuid = _.get(userDetails, "uuid")
  const toggleVisibility = () => {
    if (!visible) {
      FirebaseService.write(
        null,
        `${FirebaseService.getDefaultPath()}${userUuid}/${
          FIREBASE_STATE_KEYS.UNREAD_NOTIFICATION
        }`
      )
    }
    setVisible(visible => !visible)
  }
  const partnerScreen = _.get(partnerState, "activeScreen", "")
  const partnerOnline = _.get(partnerState, "presence.isOnline", false)
  const partnerAway = isPartnerAway(partnerScreen, partnerOnline)
  const cartRef = useRef()
  const [showReadyForCheckoutModal, setReadyForCheckoutModal] = React.useState(
    false
  )

  const onReadyForCheckout = async () => {
    emitter.fire(CUSTOM_EVENTS.HIDE_READY_FOR_CHECKOUT_MODAL, [])
    await FirebaseService.setActiveRoute("/checkout")
    props.history.push("/checkout")
  }

  const suggestedMenuItems = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER,
    {}
  )
  const hasPendingSuggestions = !_.isEmpty(
    Object.values(suggestedMenuItems).filter(
      item =>
        item[FIREBASE_STATE_KEYS.SUGGESTION_STATE] === SUGGESTION_STATES.PENDING
    )
  )

  const [showUnreadIndicator, setShowUnreadIndicator] = React.useState(
    hasPendingSuggestions
  )
  const partnerReadyForCheckout = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.READY_FOR_CHECKOUT,
    false
  )
  const unreadNotification = _.get(
    userState,
    FIREBASE_STATE_KEYS.UNREAD_NOTIFICATION,
    false
  )
  const toggleUnreadIndicator = visibility => setShowUnreadIndicator(visibility)
  const partnerName = getPartnerNameorNickName(
    partnerState,
    _.get(userState, "auth.partner", {})
  )

  const toggleReadyForCheckoutModal = value => () => {
    setReadyForCheckoutModal(value)
  }

  React.useEffect(() => {
    const showReadyForCheckoutModalListener = emitter.addListener(
      CUSTOM_EVENTS.SHOW_READY_FOR_CHECKOUT_MODAL,
      toggleReadyForCheckoutModal(true)
    )
    const hideReadyForCheckoutModalListener = emitter.addListener(
      CUSTOM_EVENTS.HIDE_READY_FOR_CHECKOUT_MODAL,
      toggleReadyForCheckoutModal(false)
    )

    return () => {
      showReadyForCheckoutModalListener.remove()
      hideReadyForCheckoutModalListener.remove()
    }
  }, [])
  React.useEffect(() => {
    // only mark the notifications seen when the user has no pending suggestions left,
    if (
      !!userDetails &&
      !hasPendingSuggestions &&
      (visible || showUnreadIndicator)
    ) {
      const path = `${FirebaseService.getDefaultPath()}${userDetails.uuid}/${
        FIREBASE_STATE_KEYS.CART_NOTIFICATION
      }`
      toggleUnreadIndicator(false)
      FirebaseService.write(null, path)
    }
  }, [hasPendingSuggestions, userDetails, showUnreadIndicator, visible])
  return (
    <section className="cart-popup-container" ref={cartRef}>
      <button className="cart-btn" onClick={toggleVisibility}>
        {(showUnreadIndicator ||
          partnerReadyForCheckout ||
          unreadNotification) && <span className="unread-indicator"></span>}
        <img src={foodCartIcon} alt="cart-icon" className="cart-icon" />
      </button>
      <Text textType="smallTextPrimary" className="your_plates">
        {YOUR_PLATES}
      </Text>
      <section className="cart-window-container">
        <CartView
          onClose={toggleVisibility}
          visible={visible}
          toggleUnreadIndicator={toggleUnreadIndicator}
          onReadyToCheckout={onReadyForCheckout}
          partnerAway={partnerAway}
          openCart={() => {
            if (!visible) setVisible(true)
          }}
          cartRef={cartRef}
        />
      </section>
      <CustomModal
        destroyOnClose={true}
        title={PARTNER_READY_FOR_CHECKOUT(partnerName)}
        visible={showReadyForCheckoutModal}
        footer={[
          <Button className="save-btn" onClick={onReadyForCheckout}>
            {GO_TO_CHECKOUT}
          </Button>,
        ]}
      />
    </section>
  )
})
